import { useEffect, useState } from "react";

/**
 * The value, once it has stopped changing for `waitTime` milliseconds.
 *
 * Modelled on profile-image/lib/use-debounce-effect.js, which is the repository's only existing
 * debounce and debounces an EFFECT. This debounces a VALUE instead, because the colour search
 * needs the settled term as a react-query key rather than a callback to fire: a key is what makes
 * the query cancel the request it replaced and cache the one it settles on.
 *
 * The timer is cleared on every change, so a member typing steadily makes no requests at all until
 * they pause. The first render returns the initial value immediately rather than waiting, so a
 * picker opened on a term already in the box paints its results rather than an empty grid.
 */
export function useDebouncedValue(value, waitTime) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), waitTime);

    return () => clearTimeout(timer);
  }, [value, waitTime]);

  return debounced;
}
